






























































import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import { maskDateTime, maskMoney } from '@/utils/common'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { RequestMessage, IRequestMessage, DataTablePagination } from '@/types/_'
import ChatFinanceiroStore from '@/components/financeiro-chat/store/chat-financeiro-store'
import BackofficeChatStore from './backoffice-chat-store'

@Component
export default class ViewFinanceiroBackofficeChat extends Vue {
  getRequestMessage: IRequestMessage = new RequestMessage()
  loadBackofficeChat: boolean = false

  get backofficeChatStore() {
    return getModule(BackofficeChatStore, this.$store)
  }

  get chatStore() {
    return getModule(ChatFinanceiroStore, this.$store)
  }

  get headerBackofficeChat() {
    return this.backofficeChatStore.headerBackofficeChat
  }

  get itemsBakofficeChat() {
    return this.backofficeChatStore.itemsBakofficeChat
  }

  get loadingBackofficeChat() {
    return this.loadBackofficeChat
  }

  set loadingBackofficeChat(value: boolean) {
    this.loadBackofficeChat = value
  }

  get getPagina() {
    return this.backofficeChatStore.pagina
  }

  set getPagina(value: number) {
    this.backofficeChatStore.setPagina(value)
  }

  get getTotalBackofficeChats() {
    return this.backofficeChatStore.totalBackofficeChats || 0
  }

  get backofficeChatsLength() {
    return Math.ceil(this.getTotalBackofficeChats / this.backofficeChatStore.qtdPorPagina)
  }

  get getRecebimento() {
    return this.backofficeChatStore.recebimento
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  maskDateTime(value: string) {
    return maskDateTime(value)
  }

  maskMoney(value: string) {
    return maskMoney(value)
  }

  async getResults(pagina: number) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.backofficeChatStore.getBackofficeChatItems()
    EventBus.$emit('clearLoadingRequest')
  }

  getChatInfo(params: any) {
    const { totalMensagensNaoLidas = 0 } = params

    if (totalMensagensNaoLidas > 0) {
      const number = totalMensagensNaoLidas >= 1 ? totalMensagensNaoLidas : ''
      const text = totalMensagensNaoLidas > 1 ? 'Novas Mensagens' : 'Nova Mensagem'

      return { icon: 'chat', title: `${number} ${text}`, class: '-orange' }
    }

    return { icon: 'chat', title: 'Chat Aberto', class: '-yellow' }
  }

  async showChat(item: any) {
    const nomeGrupo = item.identificador
    const { hospitalId, identificador } = item
    const userId = this.$user.profile.sub

    EventBus.$emit('setLoadingRequest', { status: true, text: 'Aguardando conexão...' })

    await this.backofficeChatStore.geRecebimentoById(identificador)

    await this.chatStore.openChatModalBackoffice({
      userId,
      nomeGrupo,
      hospitalId,
      ehUsuarioAtendimento: true,
      identificador,
      mensagem: '',
      recebimento: this.getRecebimento,
    })
  }

  async updatePagination(pagination: DataTablePagination) {
    this.loadingBackofficeChat = true
    let param = ''
    if (pagination.sortBy) {
      param = pagination.descending ? `${pagination.sortBy}Desc` : `${pagination.sortBy}Asc`
    } else {
      param = ''
    }
    this.backofficeChatStore.setSortBy(param)
    await this.backofficeChatStore.getBackofficeChatItems()
    this.loadingBackofficeChat = false
  }

  async mounted() {
    EventBus.$on('receberMensagemChatRemuneracao', async (data: any) => {
      this.chatStore.addMessage(data)
    })
  }
}
